import { render } from "./RegisterUser.vue?vue&type=template&id=057f7d4f"
import script from "./RegisterUser.vue?vue&type=script&lang=js"
export * from "./RegisterUser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__